import script from "./BottomNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./BottomNav.vue?vue&type=script&lang=ts&setup=true"

import "./BottomNav.vue?vue&type=style&index=0&id=3ddfb38a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddfb38a"]])

export default __exports__